import { render, staticRenderFns } from "./DuplicateRoomModal.vue?vue&type=template&id=5011f82d&scoped=true&"
import script from "./DuplicateRoomModal.vue?vue&type=script&lang=ts&"
export * from "./DuplicateRoomModal.vue?vue&type=script&lang=ts&"
import style0 from "./DuplicateRoomModal.vue?vue&type=style&index=0&id=5011f82d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5011f82d",
  null
  
)

export default component.exports